import React from "react";
import { motion } from "framer-motion";
import "./HomeHero.scss";
import { ReactComponent as HomeIcon1 } from "../../assets/svg/homeicon1.svg";
import { ReactComponent as HomeIcon2 } from "../../assets/svg/homeicon2.svg";
import { ReactComponent as HomeIcon3 } from "../../assets/svg/homeicon3.svg";
import { ReactComponent as HomeIcon4 } from "../../assets/svg/homeicon4.svg";
import { ReactComponent as HomeIcon5 } from "../../assets/svg/homeicon5.svg";
import { ReactComponent as HomeIcon6 } from "../../assets/svg/homeicon6.svg";
import { ReactComponent as HeroSvg } from "../../assets/svg/hero-svg.svg";
// import { ReactComponent as HeroScroll } from "../../assets/svg/hero-scroll-btn.svg";
import { ReactComponent as Compass } from "../../assets/svg/Compass.svg";
import { ReactComponent as ArrDown } from "../../assets/svg/Arr-down.svg";
import { Link } from "react-router-dom";
import { homeHero2 } from "../../assets/images";

const scrollToSection = () => {
  const section = document.getElementById("recent-works");
  const offsetTop = section.offsetTop;

  // Scroll to the top of the section with smooth animation
  window.scrollTo({
    top: offsetTop,
    behavior: "smooth",
  });
};

const HomeHero = () => {
  return (
    <section className="homeHero">
      <article className="homeHero__container container flex">
        <div className="homeHero__container--contents">
          <div className="homeHero__container--contents-left">
            <div className="contents-left-title">
              <motion.h1
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                We Do The Work To Make
                <br />
                your{" "}
                <motion.span
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 1, delay: 1 }}
                >
                  business work!
                </motion.span>
              </motion.h1>

              <Link to="https://calendly.com/radiksez-promo/discovery">
                <motion.button
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  type="button"
                  className="homeHero__btn"
                >
                  <motion.span
                    initial={{ y: 20, opacity: 0, scale: 1.1 }}
                    animate={{ y: 0, opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8, delay: 0.6 }}
                  >
                    Schedule a meeting
                  </motion.span>

                  <motion.div
                    initial={{ y: 20, opacity: 0, scale: 1.15 }}
                    animate={{ y: 0, opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8, delay: 0.6 }}
                  >
                    <HeroSvg />
                  </motion.div>
                </motion.button>
              </Link>
            </div>

            <div className="contents-left-subtitle">
              <motion.div
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 1, delay: 1.5 }}
                className="scroll-btn"
                onClick={scrollToSection}
              >
                <span>Portfolio</span>
                <ArrDown />
              </motion.div>

              <div className="contents-left-subtitle--text">
                <motion.div
                  initial={{ x: -30, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 1, delay: 2 }}
                >
                  <Compass />
                </motion.div>
                <motion.h2
                  initial={{ x: 30, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 1, delay: 2 }}
                >
                  Our talent pool is a force multiplier, equipped with the
                  latest technology and a deep understanding of your business
                  needs.
                </motion.h2>
              </div>
            </div>
          </div>

          <div className="homeHero__container--contents-right">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 1 }}
            >
              <HomeIcon1 className="vector-1" />
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 1.5 }}
            >
              <HomeIcon2 className="vector-2" />
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 2 }}
            >
              <HomeIcon6 className="vector-6" />
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 2.5 }}
            >
              <HomeIcon5 className="vector-5" />
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 3 }}
            >
              <HomeIcon3 className="vector-3" />
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 3.5 }}
            >
              <HomeIcon4 className="vector-4" />
            </motion.div>

            <motion.figure
              className="contents-right-img"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.5 }}
            >
              <img
                src={homeHero2}
                width={2000}
                height={2000}
                quality={100}
                alt="HomeHero1"
              />
            </motion.figure>
          </div>
        </div>
      </article>
    </section>
  );
};

export default HomeHero;
